import React, { useRef, useEffect } from 'react';

const WatermarkedImage = ({ imageUrl, watermarkUrl, watermarkOpacity, watermarkSize, watermarkPosition }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        const image = new Image();
        const watermarkImage = new Image();

        image.src = imageUrl;
        watermarkImage.src = watermarkUrl;

        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            context.drawImage(image, 0, 0);

            watermarkImage.onload = () => {
                context.drawImage(image, 0, 0);

                context.globalAlpha = watermarkOpacity;

                const scaledWidth = watermarkImage.width * watermarkSize;
                const scaledHeight = watermarkImage.height * watermarkSize;

                let x;
                let y;
                switch (watermarkPosition) {
                case 'top-left':
                    x = 10;
                    y = 10;
                    break;
                case 'top-right':
                    x = canvas.width - scaledWidth - 10;
                    y = 10;
                    break;
                case 'bottom-left':
                    x = 10;
                    y = canvas.height - scaledHeight - 10;
                    break;
                case 'bottom-right':
                    x = canvas.width - scaledWidth - 10;
                    y = canvas.height - scaledHeight - 10;
                    break;
                default:
                    x = 10;
                    y = 10;
                }

                context.drawImage(watermarkImage, x, y, scaledWidth, scaledHeight);
            };
        };
    }, [imageUrl, watermarkUrl, watermarkOpacity, watermarkSize, watermarkPosition]);

    return <canvas className="w-full h-full" style={{ objectFit: 'cover', borderRadius: '7px' }} ref={canvasRef} />;
};

export default WatermarkedImage;
